import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorComponent } from './features/pages/error/error.component';

import { HomeOneComponent } from './features/pages/home-one/home-one.component';
import { AboutComponent } from './features/pages/about/about.component';
import { FeaturesComponent } from './features/pages/features/features.component';
import { BenefitsComponent } from './features/pages/benefits/benefits.component';
import { ScheduleComponent } from './features/pages/schedule/schedule.component';
import { ContactComponent } from './features/pages/contact/contact.component';
import { LoginComponent } from './features/pages/login/login.component';

// import { PageNotFoundComponent } from './features/pages/page-not-found/page-not-found.component';


const routes: Routes = [
  { path: '', component: HomeOneComponent },
  { path: 'error', component: ErrorComponent },
  {
    path: 'store',
    loadChildren: () => import('./features/store/store.module')
      .then(m => m.StoreModule)
  },
  // Grupo "Nosotros"
  {
    path: 'nosotros',
    data: { name: 'Nosotros' },
    children: [
      {
        path: 'quienes-somos',
        component: AboutComponent,
        data: { name: 'Quiénes somos' }
      },
      {
        path: 'instalaciones',
        component: FeaturesComponent,
        data: { name: 'Instalaciones' }
      },
      {
        path: 'convenios',
        component: BenefitsComponent, // O tu propio componente si lo tienes
        data: { name: 'Convenios' }
      },
      // Si ingresan /nosotros sin nada más, redirige a /nosotros/quienes-somos
      {
        path: '',
        redirectTo: 'quienes-somos',
        pathMatch: 'full'
      }
    ]
  },

  // Grupo "Entrena con Nosotros"
  {
    path: 'entrena-con-nosotros',
    data: { name: 'Entrena con Nosotros' },
    children: [
      {
        path: 'horarios',
        component: ScheduleComponent,
        data: { name: 'Horarios' }
      },
      // Submenú "Talleres"
      // {
      //   path: 'talleres',
      //   data: { name: 'Talleres' },
      //   children: [
      //     {
      //       path: 'danza',
      //       component: ServicesComponent,
      //       data: { name: 'Danza' }
      //     },
      //     {
      //       path: 'dibujo',
      //       component: ServiceDetailComponent,
      //       data: { name: 'Dibujo' }
      //     },
      //     {
      //       path: '',
      //       redirectTo: 'danza',
      //       pathMatch: 'full'
      //     }
    ]
  },

  //     // Submenú "Artes Marciales"
  //     {
  //       path: 'artes-marciales',
  //       data: { name: 'Artes Marciales' },
  //       children: [
  //         {
  //           path: 'mma',
  //           component: OurClassesComponent,
  //           data: { name: 'MMA' }
  //         },
  //         {
  //           path: 'tae-kwon-do',
  //           component: OurClasses2Component,
  //           data: { name: 'Tae Kwon Do' }
  //         },
  //         {
  //           path: 'muay-thai',
  //           component: ClassDetailsComponent,
  //           data: { name: 'Muay Thai' }
  //         },
  //         {
  //           path: 'zambo',
  //           component: ClassesScheduleComponent,
  //           data: { name: 'Zambo' }
  //         }
  //       ]
  //     },
  //     // Submenú "Entrenamientos Especiales"
  //     {
  //       path: 'entrenamientos-especiales',
  //       data: { name: 'Entrenamientos Especiales' },
  //       children: [
  //         {
  //           path: 'clases-privadas',
  //           component: OurTeamComponent,
  //           data: { name: 'Clases Privadas (individuales o grupales)' }
  //         },
  //         {
  //           path: 'clases-empresas',
  //           component: TeamDetailComponent,
  //           data: { name: 'Clases para Empresas' }
  //         },
  //         {
  //           path: 'clases-policia-ejercito',
  //           component: TeamDetailComponent,
  //           data: { name: 'Clases para Policía y Ejército' }
  //         }
  //       ]
  //     },
  //     {
  //       path: '',
  //       redirectTo: 'horarios',
  //       pathMatch: 'full'
  //     }
  //   ]
  // },

  { path: 'contacto', component: ContactComponent, data: { name: 'Contacto' } },
  { path: 'iniciar-sesion', component: LoginComponent, data: { name: 'Ingreso-Registro' } },

  // // Página no encontrada
  // {
  //   path: '**',
  //   component: PageNotFoundComponent,
  //   data: { name: '404 - No Encontrado' }
  // }

  // { path: '**', component: ErrorComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
